import { render, staticRenderFns } from "./AdminAlcanceModal.vue?vue&type=template&id=9b095c98&scoped=true"
import script from "./AdminAlcanceModal.vue?vue&type=script&lang=js"
export * from "./AdminAlcanceModal.vue?vue&type=script&lang=js"
import style0 from "./AdminAlcanceModal.vue?vue&type=style&index=0&id=9b095c98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b095c98",
  null
  
)

export default component.exports